export const PAYER = "Payer";
export const RECIPIENT = "Recipient";
export const USER = "User";
export const TIN = "TIN";
export const IMPORT_DATA = "ImportData";
export const FORMS = "Forms";
export const PAYMENTS = "Payment";
export const PAYMENTS_LABEL = "Provide Payment";
export const EVENTS = "Events";
export const PEOPLE = "People";
export const NOTICES = "Notices";
export const SUBMIT_FOR_REVIEW = "SubmitForReview";
export const SUBMIT_FOR_REVIEW_LABEL = "Submit for Review";
export const VIEW_TIN_MASKING = "ViewTINMasking";
export const VIEW_TIN_MASKING_LABEL = "Unmask TIN (Unmask PDF)";
export const CHECK_TIN_MATCH_LABEL = "Check TIN Match";
export const IMPORT_DATA_LABEL = "Import Data";
export const REVIEW_AND_APPROVE_FORMS = "ReviewAndApproveForms";
export const REVIEW_AND_APPROVE_FORMS_LABEL = "Review & Approve/Reject";
export const SUBMIT_TO_FORMS_PAGE_FORMS = "SubmitToFormsPageForms";
export const SUBMIT_TO_FORMS_PAGE_FORMS_LABEL = "Submit to e-file";
export const VALIDATE_NAME_REGEX = new RegExp("^[A-Za-z\\d\\-:,&.' ]*$");
export const VALIDATE_ZIP_CODE_REGEX = /^(\d{5}-\d{4}|\d{5})$/
export const FORMAT_ZIP_CODE_REGEX = /^(\d{5})(\d{4})$/
export const TIN_FORMAT_REGEX = /^\d{2}-\d{7}$|^\d{3}-\d{2}-\d{4}$/

export const PERFTEST_EMAIL_DOMAIN = "perftest";
export const INTERNAL_USER_EMAIL_DOMAINS = {
    ZENWORK : "zenwork",
    TAX1099 : "tax1099"
}

export const FORM_FIELD_NAME_TEXT = {
    FIRST_NAME_TEXT: "FirstName",
    COMPANY_NAME_TEXT: "CompanyName",
    LAST_NAME_TEXT: "LastName",
    PHONE_NUMBER_TEXT: "PhoneNumber",
    PAYER_PHONE_NUM_TEXT: "PayerPhNo",
    RECIPIENT_PHONE_NUM_TEXT: "RecipientPhNo"   
}

export const FORM_FIELD_VALIDATION_REGEX = {
    NAME_FIELD_REGEX: VALIDATE_NAME_REGEX,
    PHONE_NUMBER_REGEX: /^\d{1,15}$/
}

export const FORM_FIELD_NAMES = {
    PAYER_ID: "PayerID",  
    PAYEE_ID: "PayeeID",  
    ISSUER_ID: "IssuerID",  
}

export const FORM_NAMES = {
    FORM1042S: "Form1042S",
    FORM1095B: "Form1095B",  
}